import React, { useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';

import VrefInputField from 'ff/debrief/components/segments/VrefInputField';
import ApproachSelector from 'ff/debrief/components/segments/ApproachSelector';

const ApproachToolbar = () => {
    const [isVrefInEditMode, setIsVrefInEditMode] = useState(false);

    return (
        <>
            <Box
                sx={{
                    width: isVrefInEditMode ? '65%' : '35%',
                    maxWidth: isVrefInEditMode ? '250px' : '125px',
                    flexShrink: 0,
                }}
            >
                <VrefInputField
                    isEditMode={isVrefInEditMode}
                    setIsEditMode={setIsVrefInEditMode}
                />
            </Box>

            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <ApproachSelector
                    sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    <InputLabel variant="standard">Approach</InputLabel>
                </ApproachSelector>
            </Box>
        </>
    );
};

export default ApproachToolbar;
